﻿﻿export interface ILogisticsProvider {
    id: number;
    description: string;
    abbreviation: string;
    phoneNumber: string;
    isActive: boolean;
}
